import React, { useState, useEffect } from "react";
import { submitContactForm } from "./Apiservice";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import WhatsAppChatWidget from "./WhatsAppChatWidget";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    address: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({ ...prevForm, [name]: value }));
  };

  const handleFocus = (e) => {
    e.target.parentNode.classList.add("focus");
  };

  const handleBlur = (e) => {
    if (e.target.value === "") {
      e.target.parentNode.classList.remove("focus");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await submitContactForm(form);
      console.log("Form submitted successfully:", response);
      setForm({
        name: "",
        email: "",
        mobile: "",
        address: "",
        message: "",
      });
    } catch (error) {
      console.error("Error submitting the form", error);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component mounts
  }, []);

  const pageTitle =
    "Contact Ardor Biomed | Coconut Jelly, Burn Dressing, Sanitizer";
  const pageDescription =
    "Contact Ardor Biomed for queries on Coconut Jelly, Burn Dressing, Alcohol Free Sanitizer, and Diabetic Ulcer care. We're here to support your healing.";

  const pageUrl = "https://ardorbiomed.com/Contact";
  const featuredImage = "https://ardorbiomed.com/assets/img/logo-3.png";
  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={pageUrl} />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={featuredImage} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Ardor Biomed" />
        <meta property="og:locale" content="en_US" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={featuredImage} />
        <meta name="twitter:site" content="@ardorbiomed" />
        <meta name="twitter:creator" content="@ardorbiomed" />

        {/* Schema.org JSON-LD */}
        <script type="application/ld+json">
          {`
                {
                  "@context": "https://schema.org",
                  "@type": "BlogPosting",
                  "headline": "${pageTitle}",
                  "description": "${pageDescription}",
                  "url": "${pageUrl}",
                  "image": "${featuredImage}",
                  "author": {
                    "@type": "Organization",
                    "name": "Ardor Biomed"
                  },
                  "publisher": {
                    "@type": "Organization",
                    "name": "Ardor Biomed",
                    "logo": {
                      "@type": "ImageObject",
                      "url": "https://ardorbiomed.com/logo.png"
                    }
                  },
                  "datePublished": "2023-11-15",
                  "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "${pageUrl}"
                  }
                }
              `}
        </script>
      </Helmet>
      <div className="banner-section  ">
        <img
          src="./assets/img/bannerbreadcrumbs.jpg"
          alt="Banner"
          className="img-fluid banner-img"
        />

        <div className="breadcrumb-container ">
          <h2>Contact</h2>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>

              <li className="breadcrumb-item active" aria-current="page">
                Contact
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <div className="contact-container">
        <span className="contact-big-circle"></span>
        <img src="img/shape.png" className="contact-square" alt="" />
        <div className="contact-form">
          <div className="contact-contact-info">
            <h3 className="contact-title">Let's get in touch</h3>

            <div className="contact-info">
              <h3 className="contact-title">Address:</h3>
              <div className="contact-information">
                <i className="fas fa-map-marker-alt"></i> &nbsp;&nbsp;
                <p>
                  Ardor Biomed India PVT LTD, Unit No.9, Sakthi Industrial
                  Estate, Udumalpet Road, Pollachi - 642003.
                </p>
              </div>
              <div className="contact-information">
                <i className="icon-envelope-letter icons"></i> &nbsp;&nbsp;
                <Link to="mailto:customercare@ardorbiomed.com">
                  <p>customercare@ardorbiomed.com</p>
                </Link>
              </div>
              <div className="contact-information">
                <i className="icon-envelope-letter icons"></i> &nbsp;&nbsp;
                <Link to="mailto:sales@ardorbiomed.com">
                  <p>sales@ardorbiomed.com</p>
                </Link>
              </div>
              <div className="contact-information">
                <i className="icons icon-phone"></i>&nbsp;&nbsp;
                <Link to="tel:+919488828030">+91 9488828030</Link>
              </div>
              <div className="contact-information">
                <i className="icons icon-phone"></i>&nbsp;&nbsp;
                <Link to="tel: +919944951234"> +91 9944951234</Link>
              </div>
            </div>
            <div className="contact-social-media">
              <p>Connect with us :</p>
              <div className="contact-social-icons">
                <Link
                  to="https://wa.me/919488828030"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="ion-social-whatsapp"></i>
                </Link>

                <Link to="#">
                  <i className="icon-social-facebook icons"></i>
                </Link>
                <Link to="#">
                  <i className="icon-social-twitter icons"></i>
                </Link>
                <Link to="#">
                  <i className="icon-social-instagram icons"></i>
                </Link>
                <Link to="#">
                  <i className="icon-social-youtube icons"></i>
                </Link>
              </div>
            </div>
          </div>
          <div className="contact-contact-form">
            <span className="contact-circle contact-one"></span>
            <span className="contact-circle contact-two"></span>
            <form onSubmit={handleSubmit} autoComplete="off">
              <h3 className="contact-title">Contact us</h3>
              <div className="contact-input-container">
                <input
                  type="text"
                  name="name"
                  className="contact-input"
                  value={form.name}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                />
                <label htmlFor="name">Username</label>
                <span>Username</span>
              </div>
              <div className="contact-input-container">
                <input
                  type="email"
                  name="email"
                  className="contact-input"
                  value={form.email}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                />
                <label htmlFor="email">Email</label>
                <span>Email</span>
              </div>
              <div className="contact-input-container">
                <input
                  type="tel"
                  name="mobile"
                  className="contact-input"
                  value={form.mobile}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                />
                <label htmlFor="phone">Phone</label>
                <span>Phone</span>
              </div>
              <div className="contact-input-container contact-textarea">
                <textarea
                  type="text"
                  name="address"
                  className="contact-input"
                  value={form.address}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                ></textarea>
                <label htmlFor="message">address</label>
                <span>address</span>
              </div>
              <div className="contact-input-container contact-textarea">
                <textarea
                  name="message"
                  className="contact-input"
                  value={form.message}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                ></textarea>
                <label htmlFor="message">Message</label>
                <span>Message</span>
              </div>
              <input type="submit" value="Send" className="contact-btn" />
            </form>
          </div>
        </div>
      </div>
      <div className="contact-googlemap">
        <iframe
          width="100%"
          height="100%"
          frameBorder="0"
          style={{ border: 0 }}
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3727.0224492852135!2d77.039615274803!3d10.654634589486857!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba83363ecfa2207%3A0x18bd39f45b1a08c2!2sArdor%20Biomed%20India%20PVT%20LTD!5e1!3m2!1sen!2sin!4v1735207827172!5m2!1sen!2sin"
          allowFullScreen
          title="Google Map"
        ></iframe>
      </div>
      <WhatsAppChatWidget
        phoneNumber="+919488828030"
        companyName="Ardor Biomed"
      />
    </>
  );
};

export default Contact;
